export default __webpack_public_path__ + "static/media/prize.2d35aee6.png";